import ArchiveLayout from '@/layouts/ArchiveLayout';
import { KNOWLEDGE_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Knowledge Base',
  el: 'Γνώση',
};

const description: Record<Locale, string> = {
  en: 'In-depth knowledge and technical resources for professionals.',
  el: 'Εις βάθος γνώσεις και τεχνικοί πόροι για επαγγελματίες.',
};

const eyebrow: Record<Locale, string> = {
  en: 'KNOWLEDGE',
  el: 'ΓΝΩΣΗ',
};

const emptyState: Record<Locale, string> = {
  en: 'No knowledge articles available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμα άρθρα γνώσης αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function KnowledgeArchive() {
  return (
    <ArchiveLayout
      pageKey="knowledge"
      postType="knowledge"
      query={KNOWLEDGE_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
